import type { JSX } from 'react';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';

import { colorSystem } from '../../../theme';

/** Two panels side by side with a draggable divider; without `left` only `right` renders. */
export function TwoPanelLayout({
    defaultLeftSize = 50,
    left,
    right,
    resizeHandleColor = colorSystem.neutral.white,
}: {
    defaultLeftSize?: number;
    left?: React.ReactNode;
    right: React.ReactNode;
    resizeHandleColor?: string;
}): JSX.Element {
    if (!left) {
        return <>{right}</>;
    }

    return (
        <>
            <style>
                {`
                    .panel-resize-handle:hover {
                        background-color: ${colorSystem.blue[7]};
                        width: 3px;
                        }
                    .panel-resize-handle {
                        background-color: ${resizeHandleColor};
                        transition: background-color 0.2s ease-in-out;
                        width: 3px;
                        box-sizing: border-box;

                    }
                `}
            </style>
            <PanelGroup direction="horizontal">
                <Panel defaultSize={defaultLeftSize}>{left}</Panel>
                <PanelResizeHandle
                    hitAreaMargins={{ coarse: 0, fine: 0 }}
                    className="panel-resize-handle"
                ></PanelResizeHandle>
                <Panel defaultSize={100 - defaultLeftSize}>{right}</Panel>
            </PanelGroup>
        </>
    );
}
